import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  PLANNED:     "blue",
  LOADING:     "amber",
  IN_PROGRESS: "green",
  COMPLETED:   "green",
  CANCELLED:   "grey",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the pill has one size. */
  size?: unknown
}

/** Route status as a dot pill (Ord_RouteDetail, Ord_Routes). */
export function RouteStatusBadge({ status }: Props) {
  const { t } = useTranslation(["delivery"])
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`delivery:route.status.${status}`, { defaultValue: "-" })}</DotPill>
}
